import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import { Filter } from './filter_components';
import { SubFilterWrapper, CategoryFilterWrapper } from './styled_components';
import ScrollWrapper from '../../components_desktop/components/ScrollWrapper';

class CategoryFilter extends Component {
  renderFilter(category, index, level) {
    const { currCategoryId, categoryIdsForBrands, handleFilterClick, departmentIdsForBrands, isDesktop } = this.props;
    const active = category.id
      ? categoryIdsForBrands.includes(category.id)
      : departmentIdsForBrands.includes(category.department_id);

    return (
      <Filter
        handleFilterClick={e => {
          handleFilterClick(category.id, category.url, category.title);
        }}
        firstElem={level === 0 && index === 0}
        id={category.id}
        active={active}
        checked={category.id === currCategoryId}
        value={category.url}
        title={level <= 1 ? category.title.toUpperCase() : category.title}
        type="category"
        isDesktop={isDesktop}
        filterName="categoryUrl"
      />
    );
  }

  renderFilters(category, index, level) {
    const { isDesktop, isDesignerMode, departmentIdsForBrands } = this.props;

    if (level === 0 && isDesignerMode && !departmentIdsForBrands.includes(category.department_id)) {
      return null;
    }

    let ordered = null;

    if (level < 2 && category.sub) {
      ordered = orderBy(category.sub, ['sort', 'title'], ['asc', 'asc']);
    }

    return (
      <CategoryFilterWrapper key={`category_${index}_${level}`}>
        {this.renderFilter(category, index, level)}
        {ordered &&
          ordered.map((curr, subIndex) => (
            <SubFilterWrapper key={`filter_${index}_${subIndex}`} isDesktop={isDesktop}>
              {this.renderFilters(curr, subIndex, level + 1)}
            </SubFilterWrapper>
          ))}
      </CategoryFilterWrapper>
    );
  }

  render() {
    const { filters, isDesktop } = this.props;
    const sort = filters.sort((a, b) => a.sort - b.sort);
    return (
      <ScrollWrapper maxHeight={isDesktop ? 300 : 200}>
        {map(sort, (curr, index) => this.renderFilters(curr, index, 0))}
      </ScrollWrapper>
    );
  }
}

CategoryFilter.propTypes = {
  categoryIdsForBrands: PropTypes.array,
  departmentIdsForBrands: PropTypes.array,
  currCategoryId: PropTypes.string,
  isDesignerMode: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, url: PropTypes.string, title: PropTypes.string })),
  handleFilterClick: PropTypes.func,
  isDesktop: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default CategoryFilter;
